import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';

export type AppTheme = 'light' | 'dark';

@Injectable({
    providedIn: 'root',
})
export class ThemeService {
    private readonly storageKey = 'app_theme';
    private readonly defaultTheme: AppTheme = 'light';

    constructor(@Inject(DOCUMENT) private document: Document) {}

    initTheme(): void {
        const stored = localStorage.getItem(this.storageKey) as AppTheme | null;
        this.applyTheme(stored || this.defaultTheme);
    }

    getTheme(): AppTheme {
        const current = localStorage.getItem(this.storageKey) as AppTheme | null;
        return current || this.defaultTheme;
    }

    setTheme(theme: AppTheme): void {
        localStorage.setItem(this.storageKey, theme);
        this.applyTheme(theme);
    }

    private applyTheme(theme: AppTheme): void {
        const body = this.document?.body;
        if (!body) {
            return;
        }

        body.classList.remove('theme-light', 'theme-dark');
        body.classList.add(theme === 'dark' ? 'theme-dark' : 'theme-light');
    }
}
